import { render } from "./PromptEditData.vue?vue&type=template&id=4d711926"
import script from "./PromptEditData.vue?vue&type=script&lang=js"
export * from "./PromptEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__